import React from 'react';
import { useRecoilValue } from 'recoil';
import { isMobileState } from '../../recoil/selectors';
import { assetPathFn, sizeImage } from '../../util';
import styles from './ProductReviewQuote.module.scss';

export const ProductReviewQuote: React.FC<{
  quoteText?: string | React.ReactNode;
  author?: string;
  imgName: string;
  backgroundColor?: string;
  leftPanelMaxWidth?: string;
  leftPanelStyles?: React.CSSProperties;
  rightPanelStyles?: React.CSSProperties;
  rightPanelMaxWidth?: string;
  quotes?: { quoteText: string; author: string }[];
  spaceEvenly?: boolean;
}> = ({ quoteText, author, imgName, backgroundColor, leftPanelMaxWidth, rightPanelMaxWidth, leftPanelStyles, rightPanelStyles, quotes, spaceEvenly }) => {
  const isMobile = useRecoilValue(isMobileState);

  if (isMobile) {
    return (
      <div className={styles.productVideoReviewQuote}>
        <div>
          {quoteText && <div className={styles.quote}>{quoteText}</div>}
          {author && <div className={styles.quoteBy}>{author}</div>}
          {quotes?.map((quote, i) => {
            return (
              <div key={i} className={styles.quoteList}>
                <img src={assetPathFn('lander-quote-review-stars.png')} alt="5 stars" />
                <div className={styles.quote}>{quote.quoteText}</div>
                <div className={styles.quoteBy}>{quote.author}</div>
              </div>
            );
          })}
        </div>
        <div>
          <img src={assetPathFn(sizeImage(imgName, 'x900'))} alt="customer quote" />
        </div>
      </div>
    );
  }
  const customStyles: React.CSSProperties = {};
  if (backgroundColor) {
    customStyles.backgroundColor = backgroundColor;
  }
  if (spaceEvenly) {
    customStyles.justifyContent = 'space-evenly';
  }

  return (
    <div className={styles.productVideoReviewQuote} style={customStyles}>
      <img
        src={assetPathFn(imgName)}
        alt="customer quote"
        className={styles.leftSide}
        style={leftPanelMaxWidth ? { maxWidth: leftPanelMaxWidth, ...leftPanelStyles } : leftPanelStyles}
      />
      <div className={styles.rightSide} style={rightPanelMaxWidth ? { maxWidth: rightPanelMaxWidth, ...rightPanelStyles } : rightPanelStyles}>
        {quoteText && <div className={styles.quote}>{quoteText}</div>}
        {author && <div className={styles.quoteBy}>{author}</div>}
        {quotes?.map((quote, i) => {
          return (
            <div key={i} className={styles.quoteList}>
              <img src={assetPathFn('lander-quote-review-stars.png')} alt="5 stars" />
              <div className={styles.quote}>{quote.quoteText}</div>
              <div className={styles.quoteBy}>{quote.author}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProductReviewQuote;
